import type { Menu } from '@ps/web-martech-cms-types';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';

import Arrow from '@swf/core/assets/icons/arrow.svg';

import SEOMenu from '../SEOMenu/SEOMenu';

import { TXTCLI_More } from './MoreSection.messages.json';
import styles from './MoreSection.scss';

interface Props {
  seoMenu: Menu;
  seoDepth: number;
  onClick(): void;
}

const MoreSection: React.FC<Props> = ({ seoMenu, seoDepth, onClick }) => {
  const [showMore, setShowMore] = useState(false);
  const seoItemsRef = useRef<HTMLDivElement>(null);

  const handleClick = useCallback(() => {
    setShowMore(!showMore);
  }, [showMore]);

  useEffect(() => {
    if (showMore && seoItemsRef.current !== null) {
      scrollIntoView(seoItemsRef.current, { scrollMode: 'if-needed', behavior: 'smooth' });
    }
  }, [showMore]);

  return (
    <>
      <div className={styles.showMore} onClick={handleClick}>
        <Translation {...TXTCLI_More} />
        <Arrow className={classNames(styles.arrow, { [styles.closed]: !showMore })} />
      </div>
      {showMore && (
        <div ref={seoItemsRef} className={styles.seoItems}>
          <SEOMenu seoMenu={seoMenu} seoDepth={seoDepth} onClick={onClick} />
        </div>
      )}
    </>
  );
};

export default MoreSection;
